import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import PropTypes from 'prop-types';

import PermissionsContext from '../../contexts/PermissionsContext.jsx';
import PageLoading from '../common/PageLoading.jsx';
import PermissionsErrorPage from '../PermissionsErrorPage.jsx';

function ProtectedRoute({ routeName, children }) {
  const { isLoading: authLoading } = useAuth0();
  const {
    permissions,
    loading: permissionsLoading,
    error: permissionsError,
  } = React.useContext(PermissionsContext);

  if (authLoading || permissionsLoading) {
    return <PageLoading />;
  }

  if (permissionsError) {
    if (permissionsError !== 'No user permissions found') {
      return (
        <PermissionsErrorPage message="Unable to load permissions. Please try refreshing the page." />
      );
    }
    return <PermissionsErrorPage message={permissionsError} />;
  }

  if (
    routeName &&
    !permissions.some((permission) => permission === routeName) &&
    !(routeName === 'landing' && permissions.length > 0)
  ) {
    return (
      <PermissionsErrorPage message="You do not have permission to access this application." />
    );
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(ProtectedRoute);
